import { Route, Routes } from 'react-router-dom'
import * as React from 'react'
import VesselRouter from './VesselRouter'
import SampleCollect from '../../../Pages/Sample/SampleCollect'
import SampleFind from '../../../Pages/Sample/SampleFind'
import SampleInfo from '../../../Pages/Sample/SampleInfo/SampleInfo'
import SampleRunInfo from '../../../Pages/SampleRun/SampleRunInfo'
import AnimalDetails from '../../../Pages/Animal/AnimalDetails'
import AddSampleModule from '../../../Contexts/Modules/SampleModule/AddSampleModule'
import AddSampleRouter from './AddSampleRouter'
import RenderMessage from '../../../garvan-react/Components/ModalFeedback/RenderMessage'
import NotFound from '../../NotFound'

function SampleRouter() {
  return (
    <Routes>
      <Route
        index
        element={
          <RenderMessage
            message={{
              message: '',
              subject: 'Please select page from the menu',
              severity: 'info',
              loading: false,
            }}
          />
        }
      />
      <Route
        path="vessel/*"
        element={<VesselRouter />}
      />
      <Route
        path="collect"
        element={<SampleCollect />}
      />
      <Route
        path="find"
        element={<SampleFind />}
      />
      <Route path="info">
        <Route
          path=":sample_id"
          element={<SampleInfo />}
        />
        <Route
          index
          element={<SampleInfo />}
        />
      </Route>
      <Route
        path="run"
        element={<SampleRunInfo />}
      >
        <Route
          path=":sample_run_id"
          element={<SampleRunInfo />}
        />
      </Route>
      <Route
        path="animal"
        element={<AnimalDetails />}
      >
        <Route
          path=":UAI"
          element={<AnimalDetails />}
        />
      </Route>
      <Route
        path="add/*"
        element={
          <AddSampleModule>
            <AddSampleRouter />
          </AddSampleModule>
        }
      />
      <Route
        path="*"
        element={<NotFound />}
      />
    </Routes>
  )
}

export default SampleRouter
